import axios from "../axios";

export default {
  getClassJsonApi: (id) => {
    return axios.get(`products/schedule/components/${id}`);
  },
};
